<template>
  <div id="Merci">
    <Back />

    <div class="container">
      <div class="content has-text-centered">
        <div>
          <span class="icon mdi mdi-check-bold mdi-48px has-text-primary" />
          <h2 class="subtitle has-text-primary">
            Merci !
            <br />Le formulaire a bien été envoyé, vous recevrez une réponse sous peu.
          </h2>
          <br />
          <h4 class="is-hidden subtitle has-text-weight-light">
            <a href="//facebook.com">Visitez notre page Facebook en attendant 😀</a>
          </h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Back from "@/components/Back";

export default {
  name: "Merci",
  components: {
    Back
  }
};
</script>

<style scoped>
.container {
  height: 75vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>